import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { BookingPage } from './pages/BookingPage';
import { ContactPage } from './pages/ContactPage';
import { AdminDashboard } from './pages/AdminDashboard';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/book" element={<BookingPage data-id="element-5" />} data-id="element-4" />
        <Route path="/contact" element={<ContactPage data-id="element-7" />} data-id="element-6" />
        <Route path="/admin" element={<AdminDashboard data-id="element-9" />} data-id="element-8" />
      </Routes>
    </Router>;
}